import type { SVGProps } from 'react';
const SvgRussiaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#russia-icon_svg__a)">
      <rect width={24} height={24} fill="#1A47B8" rx={12} />
      <path fill="#F93939" fillRule="evenodd" d="M-3.2 16h33.6v8H-3.2z" clipRule="evenodd" />
      <path fill="#fff" fillRule="evenodd" d="M-3.2 0h33.6v8H-3.2z" clipRule="evenodd" />
    </g>
    <rect width={23} height={23} x={0.5} y={0.5} stroke="#CDCDCD" rx={11.5} />
    <defs>
      <clipPath id="russia-icon_svg__a">
        <rect width={24} height={24} fill="#fff" rx={12} />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRussiaIcon;
